import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { SketchPicker } from 'react-color';
import { StyleControl, SkinSelector } from '../CommonProperties';

const LoginProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 스타일 변경 핸들러
  const handleStyleChange = (property, value) => {
    if (!selectedComponent) return;
    
    const existingStyle = JSON.parse(JSON.stringify(selectedComponent.style || {}));
    existingStyle[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        style: existingStyle
      }
    }));
  };
  
  // 데이터 변경 핸들러
  const handleDataChange = (property, value) => {
    if (!selectedComponent) return;
    
    const existingData = JSON.parse(JSON.stringify(selectedComponent.data || {}));
    existingData[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        data: existingData
      }
    }));
  };
  
  // componentProps 변경 핸들러 추가
  const handleComponentPropsChange = (property, value) => {
    if (!selectedComponent) return;
    
  
    
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    // 배경 타입이 변경되었을 때 추가 로직
    if (property === 'backgroundType') {
      
      
      // 배경 타입이 'none'으로 변경되었을 때 배경 URL 비우기
      if (value === 'none') {
        existingProps['backgroundUrl'] = '';
        
        // DOM에 직접 적용 (강제 스타일 적용)
        setTimeout(() => {
          try {
            // 컴포넌트 ID로 DOM 요소 찾기
            const loginElement = document.querySelector(`[id^="component-"][id$="${selectedComponent.id}"]`);
            if (loginElement) {
              
              // 모든 인라인 스타일 제거 후 다시 적용
              const oldStyle = loginElement.getAttribute('style') || '';
              loginElement.removeAttribute('style');
              
              // 배경 관련 스타일만 제거하고 나머지는 유지
              const newStyle = oldStyle
                .split(';')
                .filter(s => !s.includes('background'))
                .join(';');
              
              loginElement.setAttribute('style', 
                newStyle + '; background: none !important; background-image: none !important; background-color: transparent !important;'
              );
              
              // 클래스 추가
              loginElement.classList.add('force-no-background');
              loginElement.classList.add('no-background');
              
              // 인라인 스타일 직접 설정
              loginElement.style.background = 'none';
              loginElement.style.backgroundImage = 'none';
              loginElement.style.backgroundColor = 'transparent';
              
              // data 속성 추가 (CSS 선택자용)
              loginElement.setAttribute('data-background-type', 'none');
              
              // 비디오 요소 제거
              const videoElement = loginElement.querySelector('video');
              if (videoElement) {
                videoElement.remove();
                
              }
              
              // 오버레이 제거
              const overlayElement = loginElement.querySelector('.background-overlay');
              if (overlayElement) {
                overlayElement.remove();
                
              }
              
              // 전역 스타일 강제 적용
              const existingStyle = document.getElementById(`no-bg-style-${selectedComponent.id}`);
              if (existingStyle) {
                existingStyle.remove();
              }
              
              const styleElement = document.createElement('style');
              styleElement.id = `no-bg-style-${selectedComponent.id}`;
              styleElement.textContent = `
                /* 로그인 폼 컴포넌트 자체의 배경만 제거 */
                [id^="component-"][id$="${selectedComponent.id}"] {
                  background: none !important;
                  background-image: none !important;
                  background-color: transparent !important;
                  background-size: auto !important;
                  background-position: initial !important;
                  background-repeat: initial !important;
                }
                
                /* 비디오 요소 완전 숨김 */
                [id^="component-"][id$="${selectedComponent.id}"] video,
                [id^="component-"][id$="${selectedComponent.id}"] .background-overlay {
                  display: none !important;
                  visibility: hidden !important;
                  opacity: 0 !important;
                  height: 0 !important;
                  width: 0 !important;
                  position: absolute !important;
                  pointer-events: none !important;
                  z-index: -999 !important;
                }
              `;
              document.head.appendChild(styleElement);
            } else {
              
            }
          } catch (err) {
            
          }
        }, 100);
      }
    }
    
    // dispatch 전 최종 상태 확인
    
    
    const updateAction = {
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    };
    
    // 🔍 DEBUG: Log when skin is being saved
    if (property === 'skin') {
    }
    
    dispatch(updateComponent(updateAction));
    
    // 상태 업데이트 확인을 위한 타이머 설정
    setTimeout(() => {
      if (property === 'skin') {
      }
    }, 300);
  };
  
  return (
    <>
      {/* 스킨 선택 UI - 공통 컴포넌트 사용 */}
      <SkinSelector 
        selectedComponent={selectedComponent}
        onSkinChange={(skinId) => handleComponentPropsChange('skin', skinId)}
      />
      
      <div className="property-group">
        <label style={{ minWidth: '30%' }}>제목 텍스트</label>
        <input 
          type="text" 
          value={selectedComponent.content?.title || selectedComponent.data?.title || selectedComponent.componentProps?.title || '로그인'} 
          onChange={(e) => {
            // data와 content 모두에 저장
            handleDataChange('title', e.target.value);
            
            // content에도 저장
            const existingContent = JSON.parse(JSON.stringify(selectedComponent.content || {}));
            existingContent.title = e.target.value;
            
            dispatch(updateComponent({
              id: selectedComponent.id,
              changes: {
                content: existingContent
              }
            }));
            
            // componentProps에도 저장
            handleComponentPropsChange('title', e.target.value);
          }}
        />
      </div>

      <div className="property-group">
        <label style={{ minWidth: '30%' }}>버튼 색상</label>
        <SketchPicker 
          color={selectedComponent.style.buttonColor || '#4a90e2'} 
          onChange={(color) => handleStyleChange('buttonColor', color.hex)}
        />
      </div>

      {/* 텍스트 색상 섹션 추가 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 19.5v-15A2.5 2.5 0 016.5 2H20v20H6.5a2.5 2.5 0 01-2.5-2.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 11l3 3M9 14l3-3M9 8h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          텍스트 색상
        </div>
        <div className="property-control">
          <label>제목 색상</label>
          <div className="color-picker-container">
            <input 
              type="color" 
              value={selectedComponent.componentProps?.titleColor || '#333333'} 
              onChange={(e) => handleComponentPropsChange('titleColor', e.target.value)}
            />
          </div>
        </div>
        <div className="property-control">
          <label>라벨 색상</label>
          <div className="color-picker-container">
            <input 
              type="color" 
              value={selectedComponent.componentProps?.labelColor || '#333333'} 
              onChange={(e) => handleComponentPropsChange('labelColor', e.target.value)}
            />
          </div>
        </div>
        <div className="property-control">
          <label>입력 필드 텍스트</label>
          <div className="color-picker-container">
            <input 
              type="color" 
              value={selectedComponent.componentProps?.inputTextColor || '#333333'} 
              onChange={(e) => handleComponentPropsChange('inputTextColor', e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="property-group">
        <label style={{ minWidth: '30%' }}>배경 타입</label>
        <select
          value={selectedComponent.componentProps?.backgroundType || 'image'}
          onChange={(e) => {
            // 선택한 배경 타입
            const newBgType = e.target.value;
            
            
            // 완전히 새로운 객체 생성 (기존 속성 복사)
            const updatedComponentProps = {
              ...selectedComponent.componentProps
            };
            
            // 배경 타입 설정
            updatedComponentProps.backgroundType = newBgType;
            
            // 'none' 타입이면 배경 URL 명시적으로 비우기
            if (newBgType === 'none') {
              updatedComponentProps.backgroundUrl = '';
              
              // DOM에 직접 적용 (강제 스타일 적용)
              setTimeout(() => {
                try {
                  // 기존에 적용된 스타일 태그 제거
                  const existingStyle = document.getElementById(`no-bg-style-${selectedComponent.id}`);
                  if (existingStyle) {
                    existingStyle.remove();
                  }
                  
                  // 컴포넌트 ID로 DOM 요소 찾기
                  const loginElement = document.querySelector(`[id^="component-"][id$="${selectedComponent.id}"]`);
                  if (loginElement) {
                    
                    // 클래스 추가
                    loginElement.classList.add('force-no-background');
                    loginElement.classList.add('no-background');
                    
                    // 인라인 스타일 직접 설정
                    loginElement.style.background = 'none';
                    loginElement.style.backgroundImage = 'none';
                    loginElement.style.backgroundColor = 'transparent';
                    
                    // data 속성 추가 (CSS 선택자용)
                    loginElement.setAttribute('data-background-type', 'none');
                    
                    // 비디오 요소 제거
                    const videoElement = loginElement.querySelector('video');
                    if (videoElement) {
                      videoElement.remove();
                      
                    }
                    
                    // 오버레이 제거
                    const overlayElement = loginElement.querySelector('.background-overlay');
                    if (overlayElement) {
                      overlayElement.remove();
                      
                    }
                    
                    // 전역 스타일 강제 적용
                    const styleElement = document.createElement('style');
                    styleElement.id = `no-bg-style-${selectedComponent.id}`;
                    styleElement.textContent = `
                      /* 로그인 폼 컴포넌트 자체의 배경만 제거 */
                      [id^="component-"][id$="${selectedComponent.id}"],
                      [data-preview="true"] .login-form {
                        background: none !important;
                        background-image: none !important;
                        background-color: transparent !important;
                        background-size: auto !important;
                        background-position: initial !important;
                        background-repeat: initial !important;
                      }
                      
                      /* 비디오 요소 완전 숨김 */
                      [id^="component-"][id$="${selectedComponent.id}"] video,
                      [data-preview="true"] .login-form video,
                      [id^="component-"][id$="${selectedComponent.id}"] .background-overlay,
                      [data-preview="true"] .login-form .background-overlay {
                        display: none !important;
                        visibility: hidden !important;
                        opacity: 0 !important;
                        height: 0 !important;
                        width: 0 !important;
                        position: absolute !important;
                        pointer-events: none !important;
                        z-index: -999 !important;
                      }
                    `;
                    document.head.appendChild(styleElement);
                  } else {
                  }
                } catch (err) {
                  console.error('[LoginProperties] DOM 조작 오류:', err);
                }
              }, 100);
            } else {
              // 'none'이 아닌 타입으로 변경될 때 기존 스타일 제거
              setTimeout(() => {
                try {
                  // 기존에 적용된 스타일 태그 제거
                  const existingStyle = document.getElementById(`no-bg-style-${selectedComponent.id}`);
                  if (existingStyle) {
                    existingStyle.remove();
                  }
                  
                  // 로그인 요소 찾기
                  const loginElement = document.querySelector(`[id^="component-"][id$="${selectedComponent.id}"]`);
                  if (loginElement) {
                    // no-background 클래스 제거
                    loginElement.classList.remove('force-no-background');
                    loginElement.classList.remove('no-background');
                    
                    // 데이터 속성 설정
                    loginElement.setAttribute('data-background-type', newBgType);
                    
                    
                  }
                } catch (err) {
                  console.error('[LoginProperties] 배경 타입 변경 오류:', err);
                }
              }, 100);
            }
            
            // 새로운 객체로 일괄 변경 (객체 참조가 변경되도록)
            const updatedComponent = {
              ...selectedComponent,
              componentProps: updatedComponentProps
            };
            
            
            // 액션 디스패치
            dispatch(updateComponent({
              id: selectedComponent.id,
              changes: {
                componentProps: updatedComponentProps
              }
            }));
          }}
          style={{ width: '100%' }}
        >
          <option value="none">없음</option>
          <option value="image">이미지</option>
          <option value="video">비디오</option>
        </select>
      </div>
      <div className="property-group" style={{ 
        display: selectedComponent.componentProps?.backgroundType === 'none' ? 'none' : 'block' 
      }}>
        <label style={{ minWidth: '30%' }}>배경 URL</label>
        <input
          type="text"
          value={selectedComponent.componentProps?.backgroundUrl || ''}
          onChange={(e) => {
            const newUrl = e.target.value;
            
            
            // 완전히 새로운 객체 생성
            const updatedComponentProps = {
              ...selectedComponent.componentProps,
              backgroundUrl: newUrl
            };
            
            // URL이 비어있을 때 배경 제거 로직 추가
            if (!newUrl.trim()) {
              
              
              // DOM에 직접 적용
              setTimeout(() => {
                try {
                  // 기존 스타일 제거
                  const existingStyle = document.getElementById(`no-bg-style-${selectedComponent.id}`);
                  if (existingStyle) {
                    existingStyle.remove();
                  }
                  
                  const loginElement = document.querySelector(`[id^="component-"][id$="${selectedComponent.id}"]`);
                  if (loginElement) {
                    loginElement.classList.add('force-no-background');
                    loginElement.classList.add('no-background');
                    
                    // 인라인 스타일 직접 설정
                    loginElement.style.background = 'none';
                    loginElement.style.backgroundImage = 'none';
                    loginElement.style.backgroundColor = 'transparent';
                    
                    // 데이터 속성 설정
                    loginElement.setAttribute('data-has-background', 'false');
                    
                    // 비디오 요소 제거
                    const videoElement = loginElement.querySelector('video');
                    if (videoElement) {
                      videoElement.remove();
                    }
                  }
                } catch (err) {
                  console.error('[LoginProperties] DOM 조작 오류:', err);
                }
              }, 100);
            } else {
              // URL이 있는 경우 배경 있음 속성 설정
              setTimeout(() => {
                try {
                  // 기존 스타일 제거
                  const existingStyle = document.getElementById(`no-bg-style-${selectedComponent.id}`);
                  if (existingStyle) {
                    existingStyle.remove();
                    
                  }
                  
                  const loginElement = document.querySelector(`[id^="component-"][id$="${selectedComponent.id}"]`);
                  if (loginElement) {
                    // no-background 클래스 제거
                    loginElement.classList.remove('force-no-background');
                    loginElement.classList.remove('no-background');
                    
                    loginElement.setAttribute('data-has-background', 'true');
                    loginElement.setAttribute('data-render-count', Date.now().toString());
                    
                    // 배경 타입에 따라 스타일 적용
                    const backgroundType = selectedComponent.componentProps?.backgroundType || 'image';
                    
                    if (backgroundType === 'image') {
                      // 이미지 배경 스타일 적용
                      loginElement.style.backgroundImage = `url(${newUrl})`;
                      loginElement.style.backgroundSize = 'cover';
                      loginElement.style.backgroundPosition = 'center';
                      loginElement.style.backgroundRepeat = 'no-repeat';
                    }
                    
                    // 배경 타입이 비디오인 경우, 기존 비디오 요소를 제거하고 재생성되도록 함
                    if (backgroundType === 'video') {
                      const videoElement = loginElement.querySelector('video');
                      if (videoElement) {
                        videoElement.remove();
                        
                      }
                    }
                  }
                } catch (err) {
                  console.error('[LoginProperties] DOM 조작 오류:', err);
                }
              }, 100);
            }
            
            // 액션 디스패치
            dispatch(updateComponent({
              id: selectedComponent.id,
              changes: {
                componentProps: updatedComponentProps
              }
            }));
          }}
          placeholder="https://example.com/bg.jpg 또는 .mp4"
          style={{ width: '100%' }}
        />
      </div>
      <div className="property-group">
        <label style={{ minWidth: '30%' }}>로그인 후 이동 경로</label>
        <input
          type="text"
          value={selectedComponent.componentProps?.redirectPath || ''}
          onChange={e => handleComponentPropsChange('redirectPath', e.target.value)}
          placeholder="예: /dashboard"
          style={{ width: '100%' }}
        />
        <small style={{ color: '#6c757d', marginTop: '5px', display: 'block' }}>
          이미 로그인된 경우 또는 로그인 성공 시 이동할 경로를 지정하세요.
        </small>
      </div>
      
      {/* 공통 스타일 컨트롤 추가 */}
      <StyleControl />
    </>
  );
};

export default LoginProperties;
